export interface Testimonial {
  id: number;
  name: string;
  role: string;
  text: string;
  avatar: string;
  rating: number;
}

export interface VisualIdea {
  id: number;
  title: string;
  description: string;
  image: string;
  tags: string[];
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Roblox Coding Course",
    role: "Coding Instructor, Champ Code Academy",
    text: "Ahmad is able to learn new concepts and applies them well. While he may take more time to grasp harder concepts, his proactive approach in asking questions helps him comprehend better. Ahmad actively works on completing exercises during class, showcasing solid technical proficiency.",
    avatar: "",
    rating: 5,
  },
  {
    id: 2,
    name: "Ms Mary Lim",
    role: "Form Teacher, Bukit Panjang Primary School",
    text: "Danial is a respectful and dependable student who gets along well with his peers. He demonstrates strong responsibility with a high sense of commitment, consistently fulfilling duties and tasks assigned to him with unwavering dedication. His leadership qualities shine through in his role as CCA leader of Brass Band, where he effectively leads his fellow musicians.",
    avatar: "",
    rating: 5,
  },
  {
    id: 3,
    name: "Ms Ng",
    role: "English Teacher, Bukit Panjang Primary School",
    text: "Danial is a reliable and responsible student, who is respectful to his teachers and peers. His genuine desire to help his classmates, coupled with a strong sense of responsibility, makes him a natural leader among his peers, and a well-liked member of the class.",
    avatar: "",
    rating: 5,
  },
  {
    id: 4,
    name: "Ms Mary Lim",
    role: "Science Teacher, Bukit Panjang Primary School",
    text: "Diligent and highly motivated to learn, he listens attentively and participates actively in class discussions, creating a positive learning environment in the classroom. Keep up the good work, Danial!",
    avatar: "",
    rating: 5,
  },
  {
    id: 5,
    name: "Mr Tan",
    role: "Maths Teacher, Bukit Panjang Primary School",
    text: "Danial has shown great knowledge and understanding in class discussions. He is always polite and respectful towards his peers and teachers. Keep up the good work, Danial!",
    avatar: "",
    rating: 5,
  },
  {
    id: 6,
    name: "Mdm Teresa Len",
    role: "Principal, Bukit Panjang Primary School",
    text: "When things got tough, Danial bounced right back with a smile and showed everyone what true courage looks like. His positive spirit lifted us all up during the Overseas Learning Journey to Penang, Malaysia.",
    avatar: "",
    rating: 5,
  },
];

export const visualIdeas: VisualIdea[] = [
  {
    id: 1,
    title: "Floating City Concept",
    description:
      "An architectural vision for sustainable floating cities powered by ocean waves and solar energy.",
    image:
      "https://placehold.co/600x600/4A6580/FFFFFF?text=Floating%0ACity%0AConcept",
    tags: ["Architecture", "Green Energy", "Future Cities"],
  },
  {
    id: 2,
    title: "Bio-Luminescent Forest",
    description:
      "A speculative ecosystem where plants produce their own light using genetic engineering.",
    image:
      "https://placehold.co/600x600/4A6580/FFFFFF?text=Bio-Luminescent%0AForest",
    tags: ["Biology", "Genetics", "Nature"],
  },
  {
    id: 3,
    title: "Space Elevator Blueprint",
    description:
      "Technical illustration exploring the physics and materials needed for a real space elevator.",
    image:
      "https://placehold.co/600x600/4A6580/FFFFFF?text=Space%0AElevator%0ABlueprint",
    tags: ["Physics", "Space", "Engineering"],
  },
  {
    id: 4,
    title: "Underwater Research Dome",
    description:
      "A self-sustaining underwater laboratory for studying marine biology and ocean currents.",
    image:
      "https://placehold.co/600x600/4A6580/FFFFFF?text=Underwater%0AResearch%0ADome",
    tags: ["Marine Science", "Architecture", "Research"],
  },
  {
    id: 5,
    title: "Solar-Powered Drone Swarm",
    description:
      "Concept art for autonomous drones that harvest solar energy and pollinate crops.",
    image:
      "https://placehold.co/600x600/4A6580/FFFFFF?text=Solar%0ADrone%0ASwarm",
    tags: ["Robotics", "Agriculture", "Solar"],
  },
  {
    id: 6,
    title: "Smart Tree Network",
    description:
      "A futuristic network where trees communicate data through root systems and sensors.",
    image:
      "https://placehold.co/600x600/4A6580/FFFFFF?text=Smart%0ATree%0ANetwork",
    tags: ["IoT", "Nature", "Data Science"],
  },
];

export const stats = [
  { value: "12", label: "Creative Projects Shared", suffix: "+" },
  { value: "3", label: "Areas I Enjoy Exploring", suffix: "+" },
  { value: "85", label: "Ideas Tried and Improved", suffix: "+" },
  { value: "50", label: "Stories and Notes Read", suffix: "+" },
];

export const skills = [
  {
    name: "Game Making",
    icon: "ri-gamepad-line",
    description:
      "I think about gameplay, characters, levels, and how to make games fun for players. I even make my own board games!",
  },
  {
    name: "Character Design",
    icon: "ri-brush-line",
    description:
      "I enjoy drawing characters and creating my own designs and styles.",
  },
  {
    name: "Investing",
    icon: "ri-line-chart-line",
    description:
      "I am learning how stocks, companies, and markets work, and how patience and careful research matter when making decisions.",
  },
  {
    name: "Programming",
    icon: "ri-code-s-slash-line",
    description: "I enjoy turning my ideas into interactive experiences.",
  },
  {
    name: "Problem Solving",
    icon: "ri-lightbulb-line",
    description:
      "I like figuring out how things work and solving challenges step by step.",
  },
  {
    name: "Learning New Things",
    icon: "ri-brain-line",
    description:
      "I enjoy exploring new tools, coding skills, and ways to improve my projects. I'm planning to learn a new language too!",
  },
];
